{
  "agendasAndModules": {
    "conditions": {
      "list": "Seznam podmínek",
      "filters": {
        "title": "Filtrovat podle položky formuláře",
        "actions": "Akce"
      },
      "confirmationDeletionModal": {
        "title": "Opravdu chcete smazat podmínku?",
        "description": "Potvrzením bude podmínka smazána."
      }
    },
    "numberOfSelectedValues": "Počet vybraných hodnot"
  },
  "modulesAndAgendas": {
    "numberFormatting": {
      "unit": "Jednotka",
      "separator": {
        "label": "Oddělovač tisíců",
        "none": "Žádný",
        "space": "Mezera",
        "dot": "Tečka",
        "comma": "Čárka"
      },
      "mathRound": {
        "label": "Matematické zaokrouhlení",
        "arithmetic": "Aritmetické",
        "up": "Nahoru",
        "down": "Dolů"
      },
      "roundTo": {
        "label": "Zaokrouhlit na",
        "tenthousandths": "Zaokrouhlení na nejbližší desetitisíciny",
        "thousandths": "Zaokrouhlení na nejbližší tisíciny",
        "hundredths": "Zaokrouhlení na nejbližší setiny",
        "tenths": "Zaokrouhlení na nejbližší desetiny",
        "dozens": "Zaokrouhlení na nejbližší desítky",
        "hundreds": "Zaokrouhlení na nejbližší stovky",
        "thousands": "Zaokrouhlení na nejbližší tisíce"
      }
    },
    "sendDataToErp": {
      "modal": "Spárované sloupce",
      "pairingModal": "Spárované sloupce"
    },
    "takeDataFromErp": {
      "modal": "Spárované sloupce",
      "pairingModal": "Spárované sloupce"
    },
    "goToExternalCatalogue": {
      "sendingValuesPairing": "Spárování pro odeslání",
      "receivingRecordsPairing": "Výběr záznamu pro přijetí",
      "receivingValuesPairing": "Spárování pro přijetí",
      "shoppingCartHeader": "Hlavička nákupního košíku",
      "shoppingCartItems": "Položky nákupního košíku",
      "additionalPairing": "Doplnění u položek košíku",
      "additionalPairingRowTitle": "Namapovat pole",
      "additionalPairingTarget": "Položka z košíku",
      "additionalPairingSource": "Zdroj"
    },
    "purchaseExternalCatalogue": {
      "sendHeaderPairing": "Spárování hlavičky pro odeslání",
      "sendItemsPairing": "Spárování položek pro odeslání",
      "receiveHeaderPairing": "Spárování hlavičky pro přijetí",
      "receiveItemsPairing": "Spárování položek pro přijetí"
    },
    "buttonAdminTemplate": "Šablona Admin",
    "actions": {
      "sendDataToErpWithItems": {
        "headerPairing": "Mapování polí hlavičky",
        "recordsFormItem": "Odkaz na jiný záznam",
        "itemsTemplate": "Číselník API (položky)",
        "itemsAgenda": "Agenda položek",
        "itemsPairing": "Mapování polí položek"
      },
      "addRow": "Přidat záznam",
      "addRecipient": "Přidat příjemce",
      "addressees": "Příjemci",
      "append": "Připojit",
      "createRow": "Nový záznam",
      "delete": "Smazat",
      "directValue": "Přímá hodnota",
      "changeStrategy": "Způsob úpravy",
      "notificationSetup": "Nastavení notifikace",
      "moveAction": "Přesunout akci",
      "replace": "Nahradit",
      "requiredAction": "Notifikace vyžadující akci",
      "selectedValue": "Vybraná hodnota",
      "target": "Cíl",
      "source": "Zdroj",
      "selectTablesColumn": "Vybrat sloupec tabulky",
      "selectRecordsColumn": "Vybrat sloupec odkazovaného záznamu",
      "selectUsersColumn": "Vybrat atribut uživatele",
      "draft": "Návrh",
      "toSend": "K odeslání",
      "isNotEditable": "Není editovatelný",
      "mustBeIsKey": "Sloupec musí být označen jako klíč",
      "arrayValuesFormItem": "Pole hodnot pro dynamický vztah",
      "step": {
        "executeActionsForChangedRecord": "Spustit akce pro změněný záznam",
        "executeActionsForCreatedRecord": "Spustit akce pro vytvořený záznam",
        "1": {
          "_": "Výběr jiného záznamu",
          "chooseFromForm": "Vybrat prvek z formuláře",
          "catalogueValue": "Hodnota v katalogu",
          "chooseFromTemplate": "Vybrat sloupec z template",
          "modules": "Moduly",
          "agendas": "Agendy",
          "views": "Pohledy",
          "modalTitle": "Odkaz na jiný záznam",
          "noItems": "Žádné položky",
          "apiTable": "Číselník API",
          "redirectToLastCreatedRecord": "Přesměrovat na poslední vytvořený záznam"
        },
        "2": {
          "selectFilter": "Výběr filtru",
          "selectPairing": "Výběr párování",
          "selectTargetAgenda": "Výběr cílové agendy",
          "selectTargetRecords": "Výběr cílového odkazu na záznam",
          "externalFunction": "Externí funkce"
        },
        "3": {
          "selectInputs": "Výběr inputů",
          "selectOutputs": "Výběr outputů",
          "selectParameter": "Vybrat parametr"
        },
        "linkToRecord": {
          "modalTitle": "Vyberte hodnotu"
        }
      },
      "unselectedValue": {
        "error": "Musíte vybrat všechny požadované hodnoty"
      },
      "typeMismatch": {
        "error": "Typy se neshodují"
      },
      "requiredItems": {
        "error": "Musíte přidat alespoň jednu položku"
      },
      "arrayValuesFormItemRequired": {
        "error": "Musíte vybrat zdrojové pole pro hodnoty vázaných záznamů"
      },
      "requiredParamsNotSelected": {
        "error": "Musíte vybrat všechny požadované parametry"
      }
    },
    "change": {
      "modal": "Hodnoty pro změnu záznamu"
    },
    "condition": {
      "action": "Akce",
      "add": "Přidat",
      "applyToAll": "Definovat u všech atributů sekce",
      "comparison": "Porovnání",
      "comparisonIsBiggerByTooltip": "Je větší nebo roven (zdroj +/- hodnota)",
      "comparisonIsSmallerByTooltip": "Je menší nebo roven (zdroj +/- hodnota)",
      "comparisonIsBiggerTooltip": "Je větší než zdroj nebo hodnota",
      "comparisonIsSmallerTooltip": "Je menší než zdroj nebo hodnota",
      "currentState": "Aktuální stav",
      "function": "Funkce",
      "overwrite": "Přepsat",
      "previousState": "Předchozí stav",
      "repeat": "Opakovat",
      "sectionName": "Jméno sekce",
      "sectionDescription": "Popis sekce",
      "source": "Zdroj",
      "success": {
        "add": "Podmínka byla úspěšně přidána",
        "deleted": "Podmínka byla úspěšně smazána",
        "reordered": "Pořadí bylo úspěšně změněno",
        "stateChanged": "Stav byl úspěšně změněn",
        "updated": "Podmínka byla úspěšně upravena"
      },
      "errors": {
        "conditions": "Musíte vybrat alespoň jednu podmínku",
        "actions": "Musíte vybrat alespoň jednu akci",
        "missingConditionsError": "Musíte vybrat alespoň jednu podmínku",
        "notCompleteError": "Podmínka není kompletní"
      },
      "state": {
        "_": "Stav",
        "logicalOperator": "Logický operátor",
        "editable": "Editovatelný",
        "hidden": "Skrytý",
        "visible": "Viditelný"
      },
      "template": "Šablona",
      "value": "Hodnota",
      "sourceAndValue": "Zdroj a hodnota",
      "sourcePlusMinusValue": "Zdroj +/- hodnota",
      "sourceOrValue": "Zdroj nebo hodnota",
      "whichValue": "jakou hodnotu",
      "addGroup": "Přidat skupinu",
      "addCondition": "Přidat podmínku",
      "addGroupInside": "Přidat skupinu dovnitř",
      "addConditionInside": "Přidat podmínku dovnitř"
    },
    "conditionsSection": "Nové podmínky",
    "create": {
      "modal": "Hodnoty pro vytvoření nového záznamu"
    },
    "CreatedDate": "Datum vytvoření",
    "CurrentUser": "Aktuální uživatel",
    "DateNow": "Aktuální datum a čas",
    "distinctForEach": {
      "modal": "Hodnoty pro vytvoření nového záznamu"
    },
    "createForEach": {
      "modal": "Hodnoty pro vytvoření nového záznamu"
    },
    "dialog": {
      "behavior": {
        "label": "Chování",
        "DiscardAndSave": "Zahodit a uložit",
        "KeepAndSave": "Ponechat a uložit",
        "Keep": "Ponechat"
      },
      "formItems": "Položky formuláře"
    },
    "form": {
      "checked": "Zaškrtnuto",
      "clear": "Vyprázdnit sekci",
      "clearContent": "Opravdu chcete vyprázdnit obsah sekce?",
      "confirmAction": "Potvrdit akci",
      "runAction": "Spustit",
      "RunActionsWithoutSaving": "Spustit akci bez uložení.",
      "SaveButDoNotRunActions": "Uložit, ale nespouštět akce.",
      "NotifyUserToSave": "Opravdu chcete spustit tuto akci?",
      "delete": "Smazat sekci",
      "deleteItem": "Smazat položku sekce",
      "deleteContent": "Opravdu chcete smazat celou sekci včetně všech jejích položek? Pokud má některá položka závislosti, smazání se neprovede. Tyto vazby je nutné nejprve vyřešit samostatně.",
      "deleteSectionConflict": "Některé položky této sekce jsou používány jinde v systému. Nejprve je vyřešte u příslušné položky a poté zkuste sekci smazat znovu.",
      "deleteItemContent": "Opravdu chcete smazat položku sekce?",
      "deleteItemFlow": {
        "blockingDependencies": "Kde se položka používá",
        "cleanupTitle": "Smažou se také související nastavení",
        "blockedTitle": "Tuto položku formuláře nelze smazat",
        "blockedDescription": "Před smazáním položky formuláře odstraňte všechny blokující závislosti.",
        "cleanupDescription": "Spolu s položkou formuláře se smažou níže uvedené sekce, pravidla viditelnosti a akce mazání upozornění. Každá sekce se smaže celá, i když položku používá jen jedno pravidlo nebo akce.",
        "deleteWithDependencies": "Smazat položku i související nastavení",
        "dependencyCount": "Počet závislostí: {{count}}",
        "viewDetails": "Zobrazit podrobnosti",
        "affectedSections": "Sekce ke smazání",
        "regularSection": "Sekce podmínek",
        "recurrentSection": "Sekce hromadných změn",
        "globalVisibilityCleanup": "Pravidla viditelnosti ke smazání",
        "deleteNotificationsCleanup": "Akce mazání upozornění ke smazání",
        "deleteNotificationAction": "Akce {{actionId}}",
        "deleteNotificationOwnerSection": "Vlastník sekce: {{sectionId}}",
        "preflightFailed": "Nepodařilo se ověřit, kde se položka používá. Před smazáním to zkuste znovu.",
        "dependenciesChanged": "Závislosti se po otevření dialogu změnily. Před dalším pokusem zkontrolujte obnovené údaje.",
        "deleteFailed": "Položku formuláře se nepodařilo smazat.",
        "blockers": {
          "OtherAgendaCondition": "Podmínky v ostatních agendách",
          "ForeignFieldVisibility": "Podmínky viditelnosti ostatních položek formuláře",
          "ViewUsage": "Použití v pohledech",
          "RecordData": "Vyplněné atributy záznamů",
          "FormItemDefinition": "Odkazy z definic jiných položek formuláře",
          "FormItemDefaultValue": "Odkazy z výchozích hodnot položek formuláře"
        }
      },
      "formButtons": "Výběr prvků formuláře",
      "globalSettings": "Globální nastavení",
      "globalSettingsSuccess": "Globální nastavení bylo úspěšně uloženo",
      "item": {
        "dependencies": {
          "label": "Závislosti",
          "conditions": "Podmínky",
          "bulkChanges": "Hromadné změny",
          "otherAgendas": "Ostatní agendy",
          "noOtherAgendas": "Žádné závislosti v ostatních agendách",
          "noVisibilityConditions": "Žádné podmínky viditelnosti",
          "loadFailed": "Závislosti se nepodařilo načíst",
          "module": "Modul",
          "matchingSections": "Odpovídající sekce: {{count}}",
          "matchedZones": "Odpovídající oblasti",
          "matchedActions": "Odpovídající akce",
          "states": {
            "active": "Aktivní",
            "disabled": "Zakázáno"
          },
          "noSections": "Žádné odpovídající sekce",
          "ownerFormItem": "Položka formuláře",
          "visibilitySection": "Sekce viditelnosti",
          "referencedFormItem": "Odkazuje na vybranou položku formuláře",
          "visibilityConditions": "Podmínky viditelnosti",
          "globalConditions": "Globální podmínky"
        },
        "columnSettings": {
          "invalidConfiguration": "Zkontrolujte nastavení šířky sloupců u položek: {{items}}. Pevná šířka musí být kladné celé číslo a relativní šířka musí být vybrána.",
          "title": "Šířka sloupce v tabulkovém zobrazení",
          "widthMode": "Šířka sloupce",
          "modes": {
            "auto": "Automatická",
            "fixed": "Pevná hodnota",
            "relative": "Širší/Užší"
          },
          "fixedWidth": "Šířka",
          "positiveInteger": "Zadejte kladné celé číslo.",
          "preset": "Přednastavená šířka",
          "presets": {
            "normal": "Normální",
            "wider": "Širší",
            "widest": "Nejširší"
          },
          "overflow": "Přetečení obsahu",
          "overflowModes": {
            "ellipsis": "Tři tečky + nápověda",
            "wrap": "Zalamovat"
          },
          "preview": "Náhled",
          "previewText": "Ukázka delšího obsahu buňky tabulky",
          "help": "Nastavte, jak se toto pole zobrazí jako sloupec v tabulce.",
          "modeHelp": {
            "auto": "Šířku sloupce určí tabulka automaticky.",
            "fixed": "Nastavte přesnou šířku sloupce v pixelech.",
            "relative": "Vyberte jednu ze tří přednastavených šířek sloupce."
          },
          "fixedHelp": "Pixely (px). Zadejte celé číslo větší než 0.",
          "invalidWidth": "Zadejte platnou šířku",
          "overflowHelp": {
            "ellipsis": "Text zůstane na jednom řádku. Celou hodnotu zobrazíte najetím myši nebo zaměřením buňky klávesnicí.",
            "wrap": "Celá hodnota se zobrazí na více řádcích. Výška řádku se přizpůsobí textu."
          },
          "previewColumn": "Hodnota pole",
          "previewHelp": "Ilustrační náhled. Velké šířky jsou zde omezeny dostupným místem."
        },
        "columnSelection": "Výběr sloupce",
        "multiColumnSelection": "Výběr více sloupců",
        "columnToShow": "Sloupec pro zobrazení",
        "collapse": "Načíst sekci jako sbalenou",
        "view": "Pohled",
        "viewMode": {
          "label": "Zobrazovací režim",
          "dialog": "Dialog",
          "nestedListing": "Položkový přehled",
          "portal": "Portál"
        },
        "button": {
          "label": "Jméno tlačítka",
          "placeholder": "Pojmenujte tlačítko",
          "showButtonDirectly": "Zobrazit přímo na řádku"
        },
        "comment": {
          "add": "Přidat komentář",
          "edit": "Upravit komentář",
          "text": "komentáře"
        },
        "computed": {
          "_": "Dopočtený text",
          "add": "Přidat další",
          "operation": "Operace",
          "operationType": {
            "add": "Sčítání",
            "average": "Průměr",
            "chain": "Zřetězení",
            "divide": "Dělení",
            "max": "Maximum",
            "min": "Minimum",
            "multiply": "Násobení",
            "subtract": "Odčítání"
          },
          "prefix": "Pole pro vyplnění",
          "value": "Vybrat hodnotu",
          "referencedFormItemId": "Sloupec pro operaci",
          "errors": {
            "empty": "Musíte vybrat hodnotu",
            "noJoinTypes": "Chyba: Nelze načíst typy operací"
          }
        },
        "date": {
          "from": "Vybrat hodnotu od",
          "settings": "Nastavení prvku",
          "to": "Vybrat hodnotu do",
          "value": "Hodnota"
        },
        "fileUpload": {
          "add": "Nahrát dokument",
          "text": "Kliknutím vyberte dokument nebo jej sem přetáhněte."
        },
        "placeholder": {
          "one": "Přetáhněte požadované elementy pro vytvoření formuláře.",
          "two": "Tlačítkem + přidávate další kolonku."
        },
        "records": {
          "_": "Odkaz na jiný záznam",
          "external": "Odkaz na externí záznam",
          "interactionOptions": {
            "label": "Možnosti interakce",
            "creation": "Vytváření nových záznamů",
            "editing": "Úprava existujících záznamů",
            "addition": "Přidávání existujících záznamů"
          },
          "nestedListing": {
            "addRowError": "Chyba při ukládání záznamů",
            "addRowSuccess": "Uloženo",
            "deletion": "Smazat záznamy",
            "deleteSuccess": "Záznamy byly úspěšně smazány",
            "deleteError": "Chyba při mazání záznamů"
          },
          "updateRowsSuccess": "Upraveno",
          "updateRowsError": "Chyba při úpravě záznamů",
          "conflictingRowValues": "Stejný záznam má v řádcích různé hodnoty. Sjednoťte je a uložte znovu.",
          "unsavedJoinedChanges": "Některé změny se nepodařilo uložit.",
          "calculate": {
            "fieldRequired": "Toto pole je povinné pro výpočet",
            "fillAllRequiredFields": "Prosím vyplňte všechna povinná pole před výpočtem"
          },
          "editableWithRecordDetail": "Editovat současně s detailem"
        },
        "tables": {
          "_": "Výběr z tabulek",
          "title": "Tabulky"
        },
        "user": {
          "_": "Výběr uživatele",
          "roleSelect": "Výběr role",
          "userSettingsSelect": "Výběr uživatelského nastavení"
        },
        "editSection": "Upravit sekci",
        "newSection": "Nová sekce",
        "record": {
          "directValue": "Hodnota",
          "paramsFilledError": "Musíte vyplnit všechny parametry"
        },
        "recordExternal": {
          "flowItem": "Výběr prvku flow z formuláře",
          "heliosItem": "Výběr prvku z helios šablony"
        },
        "renameSection": "Přejmenovat sekci"
      },
      "saveSuccess": "Agenda byla úspěšně uložena",
      "table": {
        "title": "Nastavení tabulky"
      },

      "warning": {
        "addInVisibility": "Aplikování nastavení se přidá ke všem existujícím nastavením na jednotlivých prvcích v rámci sekce.",
        "emptySection": "Nejsou nastavené žádné prvky ve formuláři",
        "changeInVisibility": "Aplikování nastavení nahradí všechna existující nastavení na jednotlivých prvcích v ramci sekce.",
        "sectionNameExists": "Tento název sekce již existuje",
        "moveSubTabLayoutChange": "Cílová sekce má méně sloupců nebo řádků. Rozložení všech záložek podsekcí v této sekci se změní. Chcete pokračovat?"
      }
    },
    "formSection": {
      "hasActionInputs": "Atributy editovatelné v detailu",
      "conditions": "Podmínky",
      "columnBorderColor": "Obarvení orámování atributu",
      "attributeColor": "Obarvení pozadí atributu",
      "attributeTextColor": "Barva písma atributu",
      "iconColor": "Barva ikony",
      "textStyleBold": "Tučné písmo",
      "textStyleItalic": "Kurzíva",
      "textStyleUnderlined": "Podtržené písmo",
      "labelLayout": "Rozložení popisku",
      "labelLayoutSideBySide": "Vedle sebe",
      "labelLayoutStacked": "Pod sebou",
      "labelAlign": "Zarovnání popisku",
      "valueAlign": "Zarovnání hodnoty",
      "align": {
        "left": "Vlevo",
        "center": "Na střed",
        "right": "Vpravo"
      },
      "enableConditions": "Pomocný sloupec (uživatel neuvidí)",
      "prefilters": "Podmínky předfiltrování"
    },
    "importAgenda": {
      "_": "Importovat agendu",
      "exported": "Exportovaná agenda",
      "newVersion": "Importovat novou verzi agendy",
      "invalidJSON": "Neplatný formát JSON souboru",
      "emptySelectError": "Musí být vybrány obě položky"
    },
    "linkToDifferentRecordStepModal": "Odkaz na jiný záznam",
    "maxFilesNumber": "Maximální počet souborů",
    "MobileAccess": "Mobilní přístup",
    "new": "Nová agenda",
    "rolesSection": "Role",
    "settingsSection": "Údaje pro agendu",
    "UpdatedDate": "Datum aktualizace",
    "UserEmail": "Email uživatele",
    "UserContactEmail": "Kontaktní email uživatele",
    "UserReference": "Reference",
    "UserId": "ID uživatele",
    "RealUserId": "ID skutečného uživatele",
    "IncreaseBy": "Zvýšit o",
    "DecreaseBy": "Snížit o",
    "SelectAllFromView": "Vybrat vše",
    "UserRole": "Role uživatele",
    "noticeOnSaving": {
      "title": "Upozornění na uložení",
      "none": "Bez upozornění",
      "pointOut": "Jen upozornit",
      "forcedSave": "Vynucené uložení",
      "calculate": "Přepočítat hodnoty",
      "runActionsWithoutSaving": "Spustit akce bez uložení",
      "saveButDoNotRunActions": "Uložit, ale nespouštět akce"
    },
    "confirmationModalBeforeNavigation": {
      "title": "Opravdu chcete opustit tuto stránku?",
      "description": "Potvrzením budou všechny neuložené změny uloženy."
    },
    "settings": {
      "hideInOverviews": "Skrýt v přehledech agend",
      "status": "Stav",
      "statusSelect": "Vyberte stav",
      "statuses": {
        "active": "Aktivní",
        "draft": "Návrh",
        "archived": "Archivováno"
      }
    },
    "EmptyValue": "Prázdná hodnota",
    "RecordId": "ID záznamu",
    "ParentRecordId": "ID rodičovského záznamu",
    "records": {
      "of": "z",
      "records": "záznamů"
    },
    "None": "Žádný",
    "Body": "Tělo",
    "Header": "Hlavička",
    "Status": "Stav",
    "Error": "Chyba"
  },
  "tables": {
    "deleteConfirmation": "Opravdu chcete smazat vybrané tabulky? Tato akce je nevratná.",
    "deleteViewConfirmation": "Opravdu chcete smazat vybrané pohledy? Tato akce je nevratná.",
    "modalAddtable": {
      "addColumn": "Přidat sloupec",
      "columnName": "Název sloupce",
      "editColumn": "Upravit sloupec",
      "error": {
        "missingColumns": "Tabulka musí mít alespoň jeden sloupec",
        "uniqueName": "Název tabulky musí být unikátní",
        "uniqueRequired": "Alespoň jeden sloupec musí být označen jako unikátní",
        "invalidColumnType": "Tabulka obsahuje nesprávný typ sloupce",
        "invalidMappingKey": "Tabulka obsahuje neplatné mapování REST API sloupce"
      },
      "sourceType": "Typ zdroje",
      "sourceTypeModal": {
        "title": "Vyberte typ zdroje",
        "sort": {
          "label": "Řazení typů zdrojů",
          "asc": "Od A do Z",
          "desc": "Od Z do A"
        }
      },
      "tableName": "Název tabulky",
      "tableNamePlaceholder": "Zadejte název tabulky",
      "title": {
        "_": "Přidat tabulku",
        "create": "Přidat tabulku",
        "edit": "Upravit tabulku"
      },
      "unique": "Sloupec je unikátní"
    },
    "successfully": {
      "created": "Tabulky byly úspěšně vytvořeny",
      "deleted": "Tabulky byly úspěšně smazány",
      "updated": "Tabulky byly úspěšně upraveny"
    }
  },
  "actions": {
    "actionsTypes": {
      "Archive": "Archivovat",
      "Change": "Změnit",
      "Create": "Vytvořit",
      "Dialog": "Dialogové okno",
      "Delete": "Smazat",
      "DeleteNotification": "Smazat upozornění",
      "IncreaseVersion": "Zvýšit verzi",
      "Notify": "Upozornit",
      "DistinctForeach": "Jedinečný pro všechny",
      "CreateForEach": "Vytvořit pro všechny",
      "SendDataToErp": "Odeslat data do ERP",
      "TakeDataFromErp": "Načíst data z ERP",
      "GoToExternalCatalogue": "Přesměrovat na EK",
      "PurchaseExternalCatalogue": "Odeslat objednávku do EK",
      "SendDataToErpWithItems": "Odeslat data do ERP s položkami",
      "ExternalAction": "Externí akce",
      "ExternalRestApi": "Externí Rest Api",
      "Redirect": "Přesměrovat",
      "Halt": "Zastavit"
    },
    "draft": "Návrh",
    "toSend": "K odeslání",
    "notificationValue": "Hodnota notifikace"
  },
  "agendas": {
    "modules": {
      "select": "Vyberte modul"
    }
  },
  "importAgendas": {
    "deleteConfirmation": "Opravdu chcete smazat vybrané importy? Tato akce je nevratná."
  },
  "massChange": {
    "launch": "Spustit",
    "succesfullyExecuted": "Úspěšně spuštěno"
  },
  "notificationTemplates": {
    "form": {
      "addParameter": "Přidat parametr",
      "email": "Email notifikace",
      "insertParam": "Vložit parametr",
      "name": "Jméno notifikace",
      "fallbackAdmins": "Správce notifikace",
      "fallbackAdminsTooltip": "Spravuje notifikace a dostává notifikace o tom, jakému neaktivnímu uživateli byly neúspěšně odeslány notifikace – tyto notifikace jsou přeposílány Správci notifikace",
      "fallbackAdminsEmpty": "Žádní dostupní správci",
      "fallbackAdminsError": "Nepodařilo se načíst správce",
      "inactiveUser": "Neaktivní uživatel",
      "nameRequired": "Jméno notifikace je povinné",
      "parameter": "Název parametru",
      "parameterExists": "Tento parameter již existuje",
      "parameterRequired": "Název parametru je povinný pro přidání parametru",
      "push": "Push notifikace",
      "subject": "Předmět",
      "subjectRequired": "Předmět je povinný",
      "text": "Text notifikace",
      "web": "Notifikace v aplikaci",
      "description": "Popis",
      "bodyRequired": "Text notifikace je povinný",
      "notificationRequired": "Musíte vybrat alespoň jeden typ notifikace",
      "channels": "Kanály"
    },
    "confirmationModalForLeaving": {
      "title": "Opravdu chcete opustit tuto stránku?",
      "description": "Kliknutím na potvrzení odejdete ze stránky a ztratíte neuložená data."
    },
    "confirmationModalForRemoving": {
      "title": "Opravdu si přejete odstranit tuto notifikační šablonu?",
      "description": "Kliknutím na potvrzení bude šablona odstraněna."
    },
    "title": {
      "listOfTemplates": "Notifikační šablony",
      "detailTitle": "Notifikační šablona",
      "usedByTemplates": "Šablony používající tuto notifikaci"
    }
  },
  "recurrence": {
    "label": "Opakování",
    "daily": "Denně",
    "hourly": "Hodinově",
    "monthly": "Měsíčně",
    "never": "Nikdy",
    "weekly": "Týdně",
    "yearly": "Ročně"
  },
  "recurrenceType": {
    "label": "Typ opakování",
    "patternonly": "Pouze vzor",
    "timeranged": "Časový rozsah",
    "timespecific": "Konkrétní čas"
  },
  "executeFrom": "Provést od",
  "executeTill": "Provést do",

  "restApiConnections": {
    "action": {
      "arrayBehavior": {
        "label": "Typ transformace pole",
        "TakeFirst": "Vzít první",
        "TakeLast": "Vzít poslední",
        "JoinAll": "Spojit všechny",
        "UseAll": "Použít všechny",
        "FollowLink": "Následovat odkaz",
        "DirectContent": "Přímé stažení"
      },
      "inputs": {
        "headers": "Hlavičky volání",
        "label": "Rest Api volání",
        "parameters": "Parametry volání",
        "parameterName": "Název parametru"
      },
      "arrayJsonPath": "JSON cesta pole",
      "outputs": {
        "arrayJsonPathEmptyHint": "Ponechte prázdné pro mapování jedné odpovědi. Nastavte JSON cestu k poli, aby se pro každou položku spároval a upsertoval jeden záznam.",
        "arrayJsonPathUpsertHint": "Každá položka pole se spáruje a upsertuje. Klíčové výstupy určují existující záznam.",
        "fileName": "Název souboru (nepovinné)",
        "isKey": "Klíč",
        "isKeyHint": "Spáruje existující záznam pro každou položku pole.",
        "key": "Klíč",
        "keyMustUseBody": "Klíčové výstupy mohou používat pouze Tělo.",
        "label": "Transformace výstupu",
        "sourceIgnoredInUpsert": "Tento zdroj se v režimu upsertu pole nepoužívá. Zvolte Tělo nebo Hlavičku.",
        "upsertRequiresKey": "Označte alespoň jeden výstup jako klíč. Bez klíče upsert pole nic nezapíše.",
        "upsertRequiresTargetAgenda": "V předchozím kroku vyberte jiný záznam. Bez cílové agendy upsert pole nic nezapíše."
      },
      "migrationWarning": "Tato šablona byla vytvořena před zavedením připojení. Pro pokračování prosím znovu vyberte připojení.",
      "transformationType": {
        "label": "Typ transformace hodnoty",
        "None": "Žádná",
        "Text": "Text",
        "Number": "Číslo",
        "Bool": "Logická hodnota",
        "Date": "Datum"
      }
    },
    "form": {
      "authType": "Typ autentizace",
      "authTypes": {
        "None": "Žádná",
        "BasicAuth": "Basic auth",
        "TokenAuth": "Token auth",
        "ApiKey": "API klíč",
        "OAuth2": "OAuth 2.0"
      },
      "baseUrl": "Base url",
      "basicAuthUsername": "Uživatelské jméno pro basic auth",
      "basicAuthPassword": "Heslo pro basic auth",
      "basicAuthPasswordPlaceholder": "Nechte prázdné, aby se zachovalo stávající",
      "tokenAuthLoginRequest": "Přihlašovací požadavek",
      "tokenAuthRefreshRequest": "Obnovovací požadavek",
      "tokenAuthTokenExtraction": "Extrakce tokenu",
      "tokenAuthUsername": "Uživatelské jméno pro token auth",
      "tokenAuthPassword": "Heslo pro token auth",
      "tokenAuthPasswordPlaceholder": "Nechte prázdné, aby se zachovalo stávající",
      "tokenAuthLoginHttpMethod": "HTTP metoda přihlášení",
      "tokenAuthLoginRelativeUri": "Relativní URI přihlášení",
      "tokenAuthLoginBodyTemplate": "Šablona těla přihlášení",
      "tokenAuthRefreshHttpMethod": "HTTP metoda obnovení",
      "tokenAuthRefreshRelativeUri": "Relativní URI obnovení",
      "tokenAuthRefreshBodyTemplate": "Šablona těla obnovení",
      "tokenAuthTokenPath": "Cesta k tokenu",
      "tokenAuthRefreshTokenPath": "Cesta k obnovovacímu tokenu",
      "tokenAuthTokenTtlMinutes": "TTL tokenu (minuty)",
      "tokenAuthRefreshTokenTtlMinutes": "TTL obnovovacího tokenu (minuty)",
      "name": "Název připojení",
      "title": "Rest api připojení"
    },
    "list": "Seznam rest api připojení",
    "remove": {
      "title": "Opravdu chcete smazat rest api připojení?",
      "text": "Potvrzením bude rest api připojení smazáno."
    },
    "test": {
      "warning": {
        "title": "Byla provedena změna ve formuláři",
        "description": "Formulář obsahuje hodnoty, které nejsou uloženy. Před spuštěním testu je nutné formulář uložit."
      }
    },
    "template": {
      "list": "Seznam šablon rest api",
      "remove": {
        "title": "Opravdu chcete smazat rest api šablónu?",
        "text": "Potvrzením bude rest api šablóna smazána."
      },
      "form": {
        "body": "Tělo požadavky",
        "headers": {
          "add": "Přidat hlavičku",
          "name": "Název",
          "value": "Hodnota"
        },
        "httpMethod": "Metody HTTP požadavky",
        "logLevel": "Úroveň logování",
        "name": "Název rest api",
        "parameterUsageError": "Každý definovaný parametr musí být použit (např. $parameter) v Relative URI, Body (těle) nebo v hodnotě hlavičky.",
        "relativeUri": "Relativní uri",
        "title": "Šablona rest api"
      },
      "test": {
        "label": "Test",
        "response": "Odpověď",
        "run": "Spustit test"
      }
    }
  },
  "roles": {
    "approvalPermission": "Schvalování",
    "archivePermission": "Archivace",
    "commentPermission": "Komentování",
    "createPermission": "Tvorba záznamu",
    "deletePermission": "Mazání",
    "readPermission": "Čtení",
    "title": "Flow"
  },
  "rows": {
    "deleteConfirmation": "Opravdu chcete smazat vybrané řádky? Tato akce je nevratná.",
    "successfully": {
      "added": "Řádky byly úspěšně přidány",
      "deleted": "Řádky byly úspěšně smazány",
      "updated": "Řádky byly úspěšně upraveny"
    }
  },
  "export": {
    "error": "Něco se pokazilo.",
    "sentSuccessfully": "Požadavek na export odeslán. Odkaz na vygenerovaný soubor přijde notifikací.",
    "toPdf": "Exportovat do PDF",
    "toCsv": "Exportovat do CSV",
    "toZipWithAttachments": "Exportovat s přílohami",
    "toZipWithAttachmentsAndItems": "Exportovat s přílohami a položkami",
    "allToCsv": "Exportovat vše do CSV",
    "toXlsx": "Exportovat do Excelu",
    "title": "Exportovat"
  },
  "view": {
    "recordsDisplayColumn": "Zobrazovaný atribut záznamu",
    "saveBeforePreview": "Tento pohled obsahuje neuložené změny. Před otevřením náhledu pohled uložte.",
    "sortBy": "Sortovat dle",
    "desc": "sestupně",
    "typeSelect": "Typ pohledu",
    "actionForm": "Formulářový pohled",
    "standard": "Standardní pohled",
    "calendar": "Kalendářový pohled",
    "calendarSettings": {
      "formItems": {
        "allDay": "Celodenní událost",
        "category": "Kategorie",
        "endDate": "Datum ukončení",
        "startDate": "Datum zahájení",
        "title": "Název"
      },
      "label": "Nastavení kalendáře"
    },
    "catalogue": "Katalogový pohled",
    "userSettings": "Osobní nastavení uživatele",
    "shoppingCart": "Nákupní košík",
    "shoppingCartSettings": "Nastavení nákupního košíku",
    "cartDescription": "Popis košíku",
    "cartItems": "Počet položek v košíku",
    "cartTotal": "Celková cena",
    "cartUser": "Uživatel košíku (Filtr aktuálního uživatele)",
    "submitFormItems": "Položky formuláře pro odeslání",
    "emptyCart": "Váš košík je prázdný",
    "items": "položek",
    "errors": {
      "submitFormItemsRequired": "Pro nákupní košíky je vyžadována alespoň jedna položka formuláře pro odeslání"
    },
    "showNestedListColumns": "Zobrazit sloupce položek",
    "doNotDisplay": "Nezobrazovat",
    "displayInFilter": "Zobrazit jen při filtrování",
    "displayAlways": "Vždy zobrazit",
    "displayInParentWhenFiltering": "Zobrazit v pohledu nadřazené agendy",
    "showOnlyExistingValues": "Zobrazit jen existující hodnoty ve filtru",
    "showInToolbar": "Zobrazit v panelu nástrojů"
  },
  "conditionLogs": {
    "search": "Hledat logy",
    "subtab": {
      "forEach": "Hromadné akce",
      "erp": "ERP akce"
    },
    "filter": {
      "status": "Status",
      "success": "Úspěch",
      "failed": "Selhání",
      "recordId": "ID záznamu",
      "forEachRecordId": "ID forEach záznamu",
      "conditionActionId": "ID podmínkové akce",
      "conditionSectionId": "ID podmínkové sekce",
      "dateFrom": "Datum od",
      "dateTo": "Datum do"
    },
    "table": {
      "conditionSectionName": "Název sekce podmínky",
      "actionType": "Typ akce",
      "started": "Zahájeno",
      "finished": "Dokončeno",
      "isSuccess": "Status",
      "message": "Zpráva",
      "stackTrace": "Stack trace"
    },
    "detailModal": {
      "title": "Detail logu",
      "message": "Zpráva",
      "stackTrace": "Stack trace"
    }
  },
  "conditionErpLogs": {
    "tab": "Logy ERP",
    "search": "Hledat ERP logy",
    "filter": {
      "wasCreated": "Akce ERP",
      "created": "Vytvořeno",
      "updated": "Aktualizováno",
      "templateId": "ID šablony",
      "recordId": "ID záznamu",
      "conditionSectionId": "ID podmínkové sekce",
      "conditionActionId": "ID podmínkové akce",
      "moduleId": "ID modulu",
      "dateFrom": "Datum od",
      "dateTo": "Datum do"
    },
    "table": {
      "templateId": "ID šablony ERP",
      "erpKey": "ID ERP záznamu",
      "wasCreated": "Akce"
    }
  },
  "warning": {
    "multipleUiDefinitions": "Podmínky pro zobrazení prvků se překrývají.",
    "multipleUiDefinitionsWithNames": "Podmínky pro zobrazení prvků se překrývají.\n\nPrvky s překrývajícími se podmínkami:\n"
  }
}
